/**
 * Currency utility functions for formatting and rounding
 */

/**
 * Rounds a number according to currency type
 * @param {number} value - The value to round
 * @param {string} currency - Currency code ('USD' or 'KRW')
 * @returns {number} Rounded value
 */
export function roundCurrency(value, currency) {
  if (value == null || isNaN(value)) {
    return 0;
  }

  if (currency && currency.trim() === 'KRW') {
    return Math.round(value);
  }

  // Default to USD: round to 2 decimal places
  return Number(value.toFixed(2));
}

/**
 * Rounds amount values for safe storage in SQL Server money type
 * Money type supports up to 4 decimal places
 * @param {number} value - The value to round
 * @param {string} currency - Currency code
 * @returns {number} Rounded value safe for money type
 */
export function roundForDatabase(value, currency) {
  if (value == null || isNaN(value)) {
    return 0;
  }

  if (currency && currency.trim() === 'KRW') {
    return Math.round(value);
  }

  // Round to 4 decimal places for money type, then parse to avoid floating point errors
  return parseFloat(Number(value).toFixed(4));
}
